import styled, { css } from 'styled-components';

export interface IWrapperProps {
    isClickable?: boolean;
}
export const Wrapper = styled.div<IWrapperProps>`
    padding: 5px;
    height: 42px;
    min-width: 3.5rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media only screen and (max-width: 1920px) {
        .icon-text {
            font-size: 0.65rem;
            overflow: hidden;
            white-space: nowrap;
        }
        min-width: 2rem;
        padding: 5px 2px;
    }

    @media only screen and (max-width: 1366px) {
        padding: 2px;

        .icon-text {
            font-size: 0.55rem;
        }
        min-width: 2.25rem;
    }

    ${({ isClickable }) =>
        isClickable &&
        css`
            cursor: pointer;
            &:hover {
                background: #eee;
            }
            .active-link {
                border-bottom: solid 1px;
            }
        `}
`;

export interface IIconProps {
    color?: string;
}

export const Icon = styled.span<IIconProps>`
    text-align: center;
    display: block;

    ${({ color }) =>
        color &&
        css`
            color: ${color};
        `}
`;

export const Label = styled.span`
    text-align: center;
    margin-top: 3px;
`;
